const SkeletonCell = ({ className = "w-16" }: { className?: string }) => (
  <div className={`h-[20px] animate-pulse rounded bg-gray-300 ${className}`} />
);

interface IBudgetServiceItemSkeletonProps {
  showDiscountColumn?: boolean;
  rows?: number;
}

export const BudgetServiceItemSkeleton = (props: IBudgetServiceItemSkeletonProps) => {
  const { showDiscountColumn, rows = 10 } = props;

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr
          key={`service-item-skeleton-${rowIndex}`}
          className="border-0 !border-b-0 h-[50px]"
          style={{ borderBottom: "none" }}
        >
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-10" />
          </td>
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full" />
          </td>
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full" />
          </td>
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full" />
          </td>
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full" />
          </td>
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full h-[25px]" />
          </td>
          <td className="border-0 !border-b-0 text-center" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-12 mx-auto" />
          </td>
          {showDiscountColumn && (
            <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
              <SkeletonCell className="w-full" />
            </td>
          )}
          <td className="border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-full" />
          </td>
          <td className="text-center border-0 !border-b-0" style={{ borderBottom: "none" }}>
            <SkeletonCell className="w-6 h-6 mx-auto rounded" />
          </td>
        </tr>
      ))}
    </>
  );
};
